var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40530",
    "data-name": "Group 40530",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 7,
    viewBox: "0 0 29 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4968",
    "data-name": "Ellipse 4968",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "silver"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4968-2",
    "data-name": "Ellipse 4968",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(11)",
    fill: "silver"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4968-3",
    "data-name": "Ellipse 4968",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(22)",
    fill: "silver"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.756e09b8f78ca6be9d0c07cc0e77f151.svg";
export { ForwardRef as ReactComponent };